function anyDirty($v) {
    var dirty = [];
    for (var prop in $v) {
        var cProp = prop;
        if (prop.indexOf("$") !== 0 && typeof $v[cProp] === "object") {
            dirty.push($v[cProp].$dirty);
        }
    }
    return dirty.indexOf(true) !== -1;
}
function group($v) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    if (!props)
        return $v;
    var results = props
        .map(function (p) { return typeof p === "function" ? p($v) : $v[p]; })
        .filter(function (p) { return p; });
    return {
        $dirty: results.filter(function (p) { return p.$dirty; }).length > 0,
        $error: results.filter(function (p) { return p.$error; }).length > 0,
        $invalid: results.filter(function (p) { return p.$invalid; }).length > 0,
        $pending: results.filter(function (p) { return p.$pending; }).length > 0
    };
}
export { anyDirty, group };



//////////////////
// WEBPACK FOOTER
// ./src/Helpers/Vuelidate.ts
// module id = 187
// module chunks = 2 3 4 6